// Firebase configuration and initialization
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyChQLEvW53jM4S_HFUZKailYYr9mI73E70",
  authDomain: "inner-circle-bag.firebaseapp.com",
  databaseURL: "https://inner-circle-bag-default-rtdb.firebaseio.com",
  projectId: "inner-circle-bag",
  storageBucket: "inner-circle-bag.firebasestorage.app",
  messagingSenderId: "227334569684",
  appId: "1:227334569684:web:5221e9927f0ff04c1c4541",
  measurementId: "G-SZQ27QLCY8",
};

// Initialize Firebase
const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firebase services
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

export default app;
